import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton } from "material-ui"
import FinddDatePicker from "../../common/FinddDatePicker"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import strings from "../../../localization/strings"
import { blueGrey500 } from "material-ui/styles/colors"
import moment from "moment"
import { IPayrollPayCalendar, EExceptionType, IUserFilter } from "../../../models"
import * as reportAction from "../../../actions/ReportAction"
import * as payrollHelper from "../../../helpers/payrollHelper"

interface IProps {
    selectedPayrollPayCalendar: IPayrollPayCalendar
    userFilter: IUserFilter
    handleClose(): void

    // job->Timecard report
    jobId: string

    // Timecard page report
    filterByDefaultHierarchy: boolean
    filterDirectReportsOnly: boolean
    filterByPunchHierarchy: boolean
    filterByException: boolean
    filterExceptions: EExceptionType[]
}
interface IState {
    date: Date | string
}

export default class TimecardSummaryReportDialog extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            date: new Date()
        }
        autobind(this)
    }

    onDateChange(e, value) {
        this.setState({ date: value })
    }

    handleRequestSave() {
        this.props.handleClose()
        const payGroupIds = payrollHelper.getPayGroupIdsByPayrollPayCalendar(this.props.selectedPayrollPayCalendar)
        this.props.jobId ?
            reportAction.downloadJobTimecardSummaryReport(
                AuthenticationStore.getCookieAccountId(),
                this.props.jobId,
                moment(this.state.date).utc(true).startOf("day").format(),
                payGroupIds,
                this.props.userFilter
            ) :
            reportAction.downloadTimecardSummaryReport(
                AuthenticationStore.getCookieAccountId(),
                moment(this.state.date).utc(true).startOf("day").format(),
                HierarchySettingsStore.getGlobalLevelItemFilterId(),
                payGroupIds,
                this.props.userFilter,
                this.props.filterByDefaultHierarchy,
                this.props.filterDirectReportsOnly,
                this.props.filterByPunchHierarchy,
                this.props.filterByException,
                this.props.filterExceptions
            )
    }

    render() {
        return (
            <Dialog
                open
                title={strings.TimecardSummaryReport}
                actions={[
                    <FlatButton data-intercom-target={"Timecards-Reports-Btn-CloseTimecardSummaryReportDialog"} key="cancel" label={strings.CANCEL} secondary onTouchTap={this.props.handleClose} />,
                    <FlatButton data-intercom-target={"Timecards-Reports-Btn-DownloadTimecardSummaryReport"} key="download" label={strings.Download} primary onTouchTap={this.handleRequestSave} />
                ]}
            >
                <FinddDatePicker
                    value={this.state.date}
                    onChange={this.onDateChange}
                    floatingLabelText={strings.ReportDate}
                    cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
                    firstDayOfWeek={0}
                />
            </Dialog>
        )
    }
}
